<template>
  <Modal @close="closeModal" v-bind:size="'md'">
    <template v-slot:title>Are you sure want to logout?</template>
    <template v-slot:body>
      <div>
        <button @click.prevent="logoutCabinman" class="btn btn-primary">
          Confirm
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { inject, reactive } from "vue";
import store from "@/store";

export default {
  name: "CabinmanLogoutModal",
  props: {
    modalValue: Boolean,
    cabinman: String,
  },
  components: {},
  setup(props, { emit }) {
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const payload = reactive({
      id: props.cabinman,
    });
    const closeModal = () => {
      emit("update:modelValue", false);
    };
    const logoutCabinman = () => {
      showLoader();
      store
        .dispatch("logoutCabinMan", payload)
        .then(() => {
          hideLoader();
          emit("update:modelValue", false);
        })
        .catch(() => {
          hideLoader();
          emit("update:modelValue", false);
        });
    };
    return {
      closeModal,
      logoutCabinman,
    };
  },
};
</script>

<style scoped></style>
